import BaseComponent from 'foundation/base-component';

export default class PlayerRegistrationNavigation extends BaseComponent {
    constructor(...args) {
        super(...args);

        this.currentStep = null;
        this.onChangeStore = this.onChangeStore.bind(this);
        this.onStepClick = this.onStepClick.bind(this);
    }

    static getRequiredRefs() {
        return ['steps'];
    }

    init({ store, onNavigate }) {
        this.store = store;
        this.onNavigate = onNavigate;
        this.applyState(this.store.getState());
        this.addListeners();
    }

    addListeners() {
        this.store.subscribe(this.onChangeStore);
        this.refs.steps.forEach((stepNode) => {
            stepNode.addEventListener('click', this.onStepClick.bind(this, parseInt(stepNode.dataset.stepNumber, 10)));
        });
    }

    onStepClick(step) {
        this.onNavigate(step);
    }

    onChangeStore() {
        this.applyState(this.store.getState());
    }

    applyState({ step }) {
        if (this.currentStep !== step) {
            this.setCurrentStep(step);
        }
    }

    setCurrentStep(currentStep) {
        this.refs.steps.forEach((stepNode, index) => {
            stepNode.classList.remove('form-progress__step--complete');
            stepNode.classList.remove('form-progress__step--current');
            const stepNumber = index + 1;
            if (stepNumber < currentStep) {
                stepNode.classList.add('form-progress__step--complete');
            } else if (stepNumber === currentStep) {
                stepNode.classList.add('form-progress__step--current');
            }
        });
    }
}
